import React, { Component, Fragment } from "react"

import { withAuth0 } from "@auth0/auth0-react"
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import Form from "react-bootstrap/Form"
import { FormattedMessage } from "react-intl"

import Space from "./space"

class IdentityBank extends React.Component {
  constructor(props) {
    super(props)
    this.handleCancel = this.handleCancel.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleStartVerification = this.handleStartVerification.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleVerify = this.handleVerify.bind(this)
    this.state = {
      status: "view",
      bankStatus: this.props.identity.bankStatus,
      bankAccountName: this.props.identity.bankAccountName,
      iban: this.props.identity.iban,
      bic: this.props.identity.bic,
    }
  }

  handleCancel(e) {
    e.preventDefault()
    this.setState({
      status: "view",
      alert: null,
      bankAccountName: this.state.bankAccountName_original,
      iban: this.state.iban_original,
      bic: this.state.bic_original,
    })
  }

  handleEdit(e) {
    e.preventDefault()
    this.setState({
      status: "edit",
      alert: null,
      bankAccountName_original: this.state.bankAccountName,
      iban_original: this.state.iban,
      bic_original: this.state.bic,
    })
  }

  handleInputChange(e) {
    const target = e.target
    const name = target.name
    const value = target.type === "checkbox" ? target.checked : target.value

    this.setState({ [name]: value })
  }

  handleStartVerification(e) {
    e.preventDefault()
    this.setState(
      {
        status: "start_verification",
        alert: null,
      },
      () => {
        this.props.auth0
          .getAccessTokenSilently({
            audience: process.env.GATSBY_AUTH0_AUDIENCE,
            scope: process.env.GATSBY_AUTH0_SCOPE,
          })
          .then(accessToken => {
            const url = new URL(
              "/identity/startBankVerification",
              process.env.GATSBY_API_URL
            )
            const params = {}
            Object.keys(params).forEach(key =>
              url.searchParams.append(key, params[key])
            )
            fetch(url, {
              method: "POST",
              headers: { Authorization: `Bearer ${accessToken}` },
            })
              .then(response => {
                if (response.ok) {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      bankStatus: "Verifying (2)",
                    })
                  })
                } else {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      alert: text,
                    })
                  })
                }
              })
              .catch(error => {
                this.setState({
                  status: "view",
                  alert: error.message,
                })
              })
          })
      }
    )
  }

  handleUpdate(e) {
    e.preventDefault()
    this.setState(
      {
        status: "update",
        alert: null,
      },
      () => {
        this.props.auth0
          .getAccessTokenSilently({
            audience: process.env.GATSBY_AUTH0_AUDIENCE,
            scope: process.env.GATSBY_AUTH0_SCOPE,
          })
          .then(accessToken => {
            const url = new URL(
              "/identity/updateBank",
              process.env.GATSBY_API_URL
            )
            const params = {}
            params.bankAccountName = this.state.bankAccountName
            params.iban = this.state.iban
            params.bic = this.state.bic
            Object.keys(params).forEach(key =>
              url.searchParams.append(key, params[key])
            )
            fetch(url, {
              method: "POST",
              headers: { Authorization: `Bearer ${accessToken}` },
            }).then(response => {
              if (response.ok) {
                response.text().then(text => {
                  this.setState({
                    status: "view",
                  })
                })
              } else {
                response.text().then(text => {
                  this.setState({
                    status: "edit",
                    alert: text,
                  })
                })
              }
            })
          })
      }
    )
  }

  handleVerify(e) {
    e.preventDefault()
    this.setState(
      {
        status: "verify",
        alert: null,
      },
      () => {
        this.props.auth0
          .getAccessTokenSilently({
            audience: process.env.GATSBY_AUTH0_AUDIENCE,
            scope: process.env.GATSBY_AUTH0_SCOPE,
          })
          .then(accessToken => {
            const url = new URL(
              "/identity/verifyBank",
              process.env.GATSBY_API_URL
            )
            const params = {}
            params.verificationCode = this.state.verificationCode
            Object.keys(params).forEach(key =>
              url.searchParams.append(key, params[key])
            )
            fetch(url, {
              method: "POST",
              headers: { Authorization: `Bearer ${accessToken}` },
            })
              .then(response => {
                if (response.ok) {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      bankStatus: "Verified",
                    })
                  })
                } else {
                  response.text().then(text => {
                    this.setState({
                      status: "view",
                      alert: text,
                    })
                  })
                }
              })
              .catch(error => {
                this.setState({
                  status: "view",
                  alert: error.message,
                })
              })
          })
      }
    )
  }

  render() {
    return (
      <>
        {this.state.bankStatus == "New" && (
          <Alert variant="info">
            <FormattedMessage id={"Contact us to enable bank verification."} />
          </Alert>
        )}
        {this.state.bankStatus == "Verifying (1)" && (
          <Alert variant="info">
            <FormattedMessage
              id={"We are verifying your bank information. (1)"}
            />
          </Alert>
        )}
        {this.state.bankStatus == "Verifying (2)" && (
          <Alert variant="info">
            <FormattedMessage
              id={"We are verifying your bank information. (2)"}
            />
          </Alert>
        )}
        {this.state.bankStatus == "Verified" && (
          <Alert variant="info">
            <FormattedMessage id={"Bank information verified successfully."} />
          </Alert>
        )}
        {this.state.bankStatus == "Not Verified" && (
          <Alert variant="info">
            <FormattedMessage id={"Contact us to enable bank verification."} />
          </Alert>
        )}
        {this.state.alert != null && (
          <Alert variant="danger">
            <FormattedMessage id={this.state.alert} />
          </Alert>
        )}
        <Form>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"Bank Account Name"} />
            </Form.Label>
            <Form.Control
              name="bankAccountName"
              type="text"
              value={this.state.bankAccountName}
              disabled={this.state.status != "edit"}
              onChange={this.handleInputChange}
            />
            <Form.Text className="text-muted">
              <FormattedMessage id={"Format example: Mr John Smith."} />
            </Form.Text>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"IBAN"} />
            </Form.Label>
            <Form.Control
              name="iban"
              type="text"
              value={this.state.iban}
              disabled={this.state.status != "edit"}
              onChange={this.handleInputChange}
            />
            <Form.Text className="text-muted">
              <FormattedMessage id={"Format example: BE68539007547034."} />
            </Form.Text>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"BIC"} />
            </Form.Label>
            <Form.Control
              name="bic"
              type="text"
              value={this.state.bic}
              disabled={this.state.status != "edit"}
              onChange={this.handleInputChange}
            />
            <Form.Text className="text-muted">
              <FormattedMessage id={"Format example: BBRUBEBB."} />
            </Form.Text>
          </Form.Group>
          {this.state.bankStatus == "Verifying (2)" && (
            <Form.Group>
              <Form.Label>
                <FormattedMessage id={"Verification Code"} />
              </Form.Label>
              <Form.Control
                name="verificationCode"
                type="text"
                value={this.state.verificationCode}
                disabled={this.state.status != "view"}
                onChange={this.handleInputChange}
              />
            </Form.Group>
          )}
          {this.state.status == "view" && this.state.bankStatus == "New" && (
            <>
              <Button variant="primary" onClick={this.handleEdit}>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" disabled>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "view" && this.state.bankStatus == "Ready" && (
            <>
              <Button variant="primary" onClick={this.handleEdit}>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" onClick={this.handleStartVerification}>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "start_verification" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" disabled>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "view" &&
            this.state.bankStatus == "Verifying (1)" && (
              <>
                <Button variant="primary" disabled>
                  <FormattedMessage id={"Edit"} />
                </Button>
                <Space />
                <Button variant="warning" disabled>
                  <FormattedMessage id={"Verify"} />
                </Button>
              </>
            )}
          {this.state.status == "view" &&
            this.state.bankStatus == "Verifying (2)" && (
              <>
                <Button variant="primary" disabled>
                  <FormattedMessage id={"Edit"} />
                </Button>
                <Space />
                <Button variant="warning" onClick={this.handleVerify}>
                  <FormattedMessage id={"Verify"} />
                </Button>
              </>
            )}
          {this.state.status == "verify" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" disabled>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "view" && this.state.bankStatus == "Verified" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"Edit"} />
              </Button>
              <Space />
              <Button variant="warning" disabled>
                <FormattedMessage id={"Verify"} />
              </Button>
            </>
          )}
          {this.state.status == "view" &&
            this.state.bankStatus == "Not Verified" && (
              <>
                <Button variant="primary" disabled>
                  <FormattedMessage id={"Edit"} />
                </Button>
                <Space />
                <Button variant="warning" disabled>
                  <FormattedMessage id={"Verify"} />
                </Button>
              </>
            )}
          {this.state.status == "edit" && (
            <>
              <Button variant="primary" onClick={this.handleUpdate}>
                <FormattedMessage id={"Update"} />
              </Button>
              <Space />
              <Button variant="secondary" onClick={this.handleCancel}>
                <FormattedMessage id={"Cancel"} />
              </Button>
            </>
          )}
          {this.state.status == "update" && (
            <>
              <Button variant="primary" disabled>
                <FormattedMessage id={"Update"} />
              </Button>
              <Space />
              <Button variant="secondary" disabled>
                <FormattedMessage id={"Cancel"} />
              </Button>
            </>
          )}
        </Form>
      </>
    )
  }
}

export default withAuth0(IdentityBank)
